<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div>
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char20">
                    <label class="label-caption">Referência</label>
                    <div class="field-label field-label-center">{{ objView.ref_titulo }}</div>
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo Ref</label>
                    <div class="field-label field-label-center">{{ objView.ref_protocolo }}</div>
                </div>
                
                <div class="form-item-char20">
                    <label class="label-caption">Protocolo</label>
                    <div class="field-label field-label-center">{{ objView.protocolo }}</div>
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Data</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(objView.dhprotocolo) }}</div>
                </div>
                
                <div class="form-item-char40">
                    <label class="label-caption">Situação</label>
                    <div class="field-label">{{ objView.nmstatus }}</div>
                </div>
                
                <div class="form-item">
                    <label class="label-caption">SIM</label>
                    <div class="field-label">{{ objView.nmsim }}</div>
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label field-label-start">{{ objView.nmestabelecimento }}</div>
                </div>
            </div>


            <div class="row-end">
                <button v-if="objView.idlaudo" type="button" class="btn-small" @click="visualizarLaudo(objView.idlaudo)">Laudo</button>
                <button v-if="objView.idlaudo_deferimento" type="button" class="btn-small" @click="visualizarLaudo(objView.idlaudo_deferimento)">Deferimento</button>
                <button type="button" class="btn-small" @click="closeForm">Retornar</button>
            </div>
        </div>
    </div>


    <div v-for="item in lsItens" :key="item.id" class="form-edit-page row-space">
        <div class="tela-dividida row-space">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Origem</label>
                    <div class="field-label field-label--destaque">{{ item.ref_cditem }} {{ item.ref_nmitem }}</div>
                </div>              
            </div>

            <div class="coluna">
                <div class="form-item-char15">
                    <label class="label-caption">Data Prevista</label>
                    <div class="field-label field-label-center">{{ Funcoes.formatDateFromJson(item.acdtprevista) }}</div>
                </div>
            </div>
        </div>
        

        <div class="tela-dividida">
            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Não Conformidade</label>
                    <textarea v-model="item.ref_nc" rows="5" maxlength="3000" readonly/>
                </div>
            </div>

            <div class="coluna">
                <div class="form-item">
                    <label class="label-caption">Ação Corretiva</label>
                    <textarea v-model="item.acdetalhamento" rows="5" maxlength="3000" readonly/>
                </div>
            </div>
        </div>
        

        <div class="row-space"></div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';

const emit = defineEmits(['close']);
const props = defineProps({idView: {type: Number, default: 0}});

const isLoading = ref(false);
const lsItens = ref([]);
const msgAlerta = ref(null);
const objView = ref({});

const closeForm = () => {
    emit('close'); 
};


async function lerDados() {
    try{
        isLoading.value=true;
        msgAlerta.value=null;
        
        // SELECIONA OBJETO PRINCIPAL
        const rPla08 = await Api.genericPost('/dados/rac', {
            idep: globalStore.idep,
            id: props.idView
        });
        if (rPla08.length==1){
            objView.value = rPla08[0];

            const rItens = await Api.genericPost('/dados/rac_item', {
                idep: globalStore.idep,
                idreferencia: props.idView
            });
            lsItens.value = rItens || [];
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function visualizarLaudo(idLAudo) {
    try {
        msgAlerta.value = null;
        isLoading.value = true;

        const r = await Api.genericPost('/operacoes/solicitar/download', { id: idLAudo });

        if (r.bolok === 1 && r.download_url) {
            window.open(r.download_url, '_blank');
        } else {
            msgAlerta.value = `ATENÇÃO: ${r.mensagem || 'Não foi possível abrir o anexo.'}`;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


onMounted(lerDados)
</script>

<style scoped>
.tela-dividida {
    display: flex;
    gap: 10px;
    box-sizing: border-box;
}

.coluna {
    flex: 1;
    display: flex;
    gap: 10px;
    align-items: end;
}

.esquerda {
    background-color: #3498db;
}

.direita {
    background-color: #2ecc71;
}
</style>
